module.exports = __webpack_public_path__ + "static/media/facebook-icon.0a0e94d6.svg";